var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('a',{attrs:{"href":_vm.getProductUrl}},[_c('span',[_vm._v(_vm._s(_vm.prod.name))])])])}
var staticRenderFns = []

export { render, staticRenderFns }